import { render, staticRenderFns } from "./columnHabit.vue?vue&type=template&id=6e9d6869&scoped=true&"
import script from "./columnHabit.vue?vue&type=script&lang=js&"
export * from "./columnHabit.vue?vue&type=script&lang=js&"
import style0 from "./columnHabit.vue?vue&type=style&index=0&id=6e9d6869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d6869",
  null
  
)

export default component.exports